<template>
	<modal
		v-model="isOpen"
		containerClass="review-section-info"
	>
		<span
			slot="label"
			class="glyphicon glyphicon-info-sign help"
			title="Info om recensioner"
			@click.prevent.stop="isOpen = true"
		/>
		<div>
			<h2>Recensioner på Webhallen</h2>
			<p>
				Alla betyg, recensioner och hypes på Webhallen kommer från registrerade Webhallen-medlemmar.
				Snittbetyget vi visar (1-5) är ett rakt genomsnitt av alla betyg.
			</p>
			<p>
				Alla inkomna recensioner publiceras på siten så länge de uppfyller våra
				<a-link
					:to="guideLinesLink"
					target="_blank"
				>riktlinjer</a-link>.
				Vi redigerar eller korrekturläser inga recensioner innan de publiceras.
			</p>
			<h3>Upvotes</h3>
			<p>
				Medlemmar kan tumma upp eller ner din recension beroende på vad de tyckte om den.
				Varje upvote på din recension ger 50 XP på ditt konto.
				Recensionen med flest upvotes visas också som topprecension högt upp på produktsidan.
			</p>
			<hr>
			<h3>Olika ikoner</h3>
			<p class="icon-description">
				<span
					title="Verifierad köpare"
					class="review-verified purchase"
				/>
				Verifierad köpare
			</p>
			<p class="icon-description">
				<span
					title="Verifierad förbokning"
					class="review-verified hype"
				/>
				Verifierad förbokning
			</p>
			<p class="icon-description">
				<span
					title="Jobbar på Webhallen"
					class="wh-logo"
				/>
				Jobbar på Webhallen
			</p>
		</div>
	</modal>
</template>

<script>

export default {
	data () {
		return {
			isOpen: false,
			guideLinesLink: {
				name: 'info',
				params: {
					id: 41,
					name: 'Recensioner-hos-Webhallen',
				},
			},
		};
	},
};
</script>